<template>
  <b-sidebar ref="ccSidebar" :id="id" :title="title" :backdrop-variant="backdropVariant"
             :right="isRight" :width="width" backdrop text-variant="dark"
             header-class="sidebar-right" footer-class="sidebar-right"
             :shadow="true" @hidden="hideSidebar" @shown="showSidebar">
    <template slot="footer">
      <slot name="footer"></slot>
    </template>
    <div class="px-3 py-2">
      <slot name="body"></slot>
    </div>
  </b-sidebar>
</template>

<script>
export default {
  name: "CcSidebar",
  props: {
    id: {
      type: String,
      default: 'sidebar'
    },
    title: {
      type: String,
      default: 'Title'
    },
    backdropVariant: {
      type: String,
      default: 'dark'
    },
    isRight: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '450px'
    }
  },
  methods: {
    hideSidebar() {
      this.$emit('onHiddenSidebar')
    },
    showSidebar() {
      this.$emit('onOpenedSidebar')
    }
  }
}
</script>

<style>
.multiselect__select {
  height: 100% !important;
}
.b-sidebar-body {
  background-color: rgba(190, 223, 255, .15) !important;
}
</style>
